import React from "react";
import { motion } from "framer-motion";
import { FaPlaneDeparture, FaKaaba, FaFacebook } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const UmrahTickets = () => {
  const { t } = useTranslation();

  return (
    <section className="min-h-screen bg-black text-white px-6 py-16 flex flex-col items-center">
      {/* Hero Section */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-center max-w-3xl mx-auto mb-16"
      >
        <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent">
          {t("umrahTickets.heroTitle")}
        </h1>
        <p className="text-gray-300 leading-relaxed">{t("umrahTickets.heroDesc")}</p>
      </motion.div>

      {/* Info Cards */}
      <div className="grid md:grid-cols-2 gap-10 w-full max-w-5xl mb-16">
        {/* Flights */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-[#0a0a0a]/80 backdrop-blur-md rounded-2xl p-8 shadow-lg border border-gray-800 hover:border-blue-500 transition"
        >
          <FaPlaneDeparture className="text-blue-400 text-4xl mb-4" />
          <h3 className="text-2xl font-semibold mb-3 text-white">
            {t("umrahTickets.flightTitle")}
          </h3>
          <p className="text-gray-300 leading-relaxed">
            {t("umrahTickets.flightDesc")}
          </p>
        </motion.div>

        {/* Umrah */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-[#0a0a0a]/80 backdrop-blur-md rounded-2xl p-8 shadow-lg border border-gray-800 hover:border-blue-500 transition"
        >
          <FaKaaba className="text-blue-400 text-4xl mb-4" />
          <h3 className="text-2xl font-semibold mb-3 text-white">
            {t("umrahTickets.umrahTitle")}
          </h3>
          <p className="text-gray-300 leading-relaxed">
            {t("umrahTickets.umrahDesc")}
          </p>
        </motion.div>
      </div>

      {/* Facebook Section */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-center max-w-3xl"
      >
        <h2 className="text-3xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent">
          {t("umrahTickets.facebookHeading")}
        </h2>
        <p className="text-gray-300 mb-6">{t("umrahTickets.facebookDesc")}</p>

        <a
          href="https://www.facebook.com/RawangiTravelandTours"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-blue-700 px-6 py-3 rounded-full font-semibold text-white shadow-lg hover:scale-105 transition-transform"
        >
          <FaFacebook size={22} />
          {t("umrahTickets.facebookButton")}
        </a>
      </motion.div>
    </section>
  );
};

export default UmrahTickets;
